import { useCallback, useEffect, useState } from 'react'
import type { UseFormReturn } from 'react-hook-form'
import type { AgentNodeFormSchemaType } from './agency-node-form.schema'

export const useAgentNodeImage = (
  form: UseFormReturn<AgentNodeFormSchemaType>,
  initialImageUrl?: string
) => {
  const [imagePreviewUrl, setImagePreviewUrl] = useState<string | null>(null)

  useEffect(() => {
    setImagePreviewUrl(initialImageUrl ?? null)
  }, [initialImageUrl])

  const handleImageChange = useCallback(
    (file: File | null): void => {
      if (!file) return
      const url = URL.createObjectURL(file)
      setImagePreviewUrl(url)
      form.setValue('imageUrl', url)
    },
    [form]
  )

  const handleImageRemove = useCallback((): void => {
    setImagePreviewUrl(null)
    form.setValue('imageUrl', undefined)
  }, [form])

  return {
    imagePreviewUrl,
    handleImageChange,
    handleImageRemove,
  }
}
